import { render, staticRenderFns } from "./TextAreaField.vue?vue&type=template&id=d625328e&scoped=true&"
import script from "./TextAreaField.vue?vue&type=script&lang=js&"
export * from "./TextAreaField.vue?vue&type=script&lang=js&"
import style0 from "./TextAreaField.vue?vue&type=style&index=0&id=d625328e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d625328e",
  null
  
)

export default component.exports